export default {
  menu: {
    title: "How to read and explore the chart?",
    description: [
      "This chart is an exploration tool that would help visually represent how your Cognitive Functions according to Carl Jung represent the 4-letter code of the Myer's Briggs Type Indicator (MBTI).",
      "We may not deep dive on how MBTI or Cognitive Functions work and the internet has abundance of those resources that could help you understand them.",
      "This help guide is broken down to five parts:",
    ],
    list: {
      items: [
        {
          title: "I. The Attitudes (Extraversion vs Introversion)",
          url: "attitudes",
        },
        {
          title: "II. The 4 Major Cognitive Functions",
          url: "majorcogfuncs",
        },
        {
          title: "III. The 8 Cognitive Functions",
          url: "eightcogfuncs",
        },
        {
          title: "IV. The Function Stack",
          url: "funcstack",
        },
        {
          title: "V. What does the 4 letter MBTI altogether mean?",
          url: "mbti-all-together",
        },
      ],
    },
  },
  content: [
    {
      title: "I. Your Attitudes (Extraversion vs Introversion)",
      id: "attitudes",
      subtitle: "Which Worlds Are You Often, Outer or Inner?",
      description:
        "Which worlds do you prefer to be in? Where do you spend your energy the most?",
      visual: "attitudes",
      parts: [
        {
          category: "Extraversion (E) - Your Outer World",
          description:
            "Your preference which tends to enjoy human interaction, enthusiasm, assertiveness, and talkativeness.",
        },
        {
          category: "Introversion (I) - Your Inner World",
          description:
            "Your preference where your energy tends to reflect and dwindle during human interaction.",
        },
      ],
    },
    {
      title: "II. The 4 Major Cognitive Functions",
      subtitle: "How You Gather Information and Make Decisions",
      description:
        "Your 4 major Cognitive Functions are either categorized as Perceiving (Intuition and Sensing) or Judging (Thinking and Feeling)",
      visual: "major-cogfunc",
      parts: [
        {
          category: "Perceiving",
          description:
            "Perceiving functions help you gather and organize information",
          subparts: [
            {
              subcategory: "Intuition (N)",
              description:
                "Your Intuition function helps you understand meaning and patterns of information. It has to do more with symbols or abstract theories.",
            },
            {
              subcategory: "Sensing (S)",
              description:
                "Your Sensing function focuses on your physical reality, what you see, hear, touch, taste and smell. Attention goes more into the present moment and reality.",
            },
          ],
        },
        {
          category: "Judging",
          description: "Judging functions help you make decisions",
          subparts: [
            {
              subcategory: "Thinking (T)",
              description:
                "Your Thinking function puts greater emphasis on facts and objective data and puts more weight on impersonal facts.",
            },
            {
              subcategory: "Feeling (F)",
              description:
                "Your Feeling function is more likely to consider personal concerns and people to care about and their point-of-view.",
            },
          ],
        },
      ],
    },
    {
      title: "III. The 8 Cognitive Functions",
      subtitle: "How You Process Information In Different Worlds",
      description: [
        "If we mix-and-match your extraverted and introverted worlds along with your perceiving and judging preferences, 8 different combinations of Fognitive functions are available according to Jung.",
        "Toggle the dropdown to read every function in detail",
      ],
      visual: "eight-cogfunc",
      parts: [
        {
          category: "Intuition (N)",
          subparts: [
            {
              subcategory: "Extraverted Intuition (Ne)",
              description:
                "Your idea exploration and envision function, connections & possibilities; open, curious & creative",
              isDropdownShownDefault: false,
            },
            {
              subcategory: "Introverted Intuition (Ni)",
              description:
                "Your insights and impressions function; a function used for organizing information",
              isDropdownShownDefault: false,
            },
          ],
        },
        {
          category: "Sensing (S)",
          subparts: [
            {
              subcategory: "Extraverted Sensing (Se)",
              description:
                "Your 'live in the moment' function; attuned to concrete affairs & opportunities for action",
              isDropdownShownDefault: false,
            },
            {
              subcategory: "Introverted Sensing (Si)",
              description:
                "Your past experiences function. Helps you stabilize belief and decisions by drawing on past experience & instruction",
              isDropdownShownDefault: false,
            },
          ],
        },
        {
          category: "Thinking (T)",
          subparts: [
            {
              subcategory: "Extraverted Thinking (Te)",
              description:
                "Your rational and structure function; it structures ideas, things & processes; it relies more on established methods",
              isDropdownShownDefault: false,
            },
            {
              subcategory: "Introverted Thinking (Ti)",
              description:
                "Your inner logical standard; prefers autonomy in projects, problem-solving & decision-making",
              isDropdownShownDefault: false,
            },
          ],
        },
        {
          category: "Feeling (F)",
          subparts: [
            {
              subcategory: "Extraverted Feeling (Fe)",
              description:
                "Your emotional connection with others; communicative, offering guidance & feedback; facilitates morale & consensus",
              isDropdownShownDefault: false,
            },
            {
              subcategory: "Introverted Feeling (Fi)",
              description:
                "Your reflections on personal feelings and values function; champions authenticity & individuality",
              isDropdownShownDefault: false,
            },
          ],
        },
      ],
    },
    {
      title: "IV. The Function Stack",
      subtitle: "Your Favorite Functions and Some You Don’t Like To Use Often",
      description: [
        "There are functions we prioritize and likes to use often. Due to this prioritization we end up deprioritize other functions.",
        "Primary functions are your 4 major functions and ordered according to your preference. This order is called the Function Stack.",
        "Shadow functions are the hidden and unconscious function (the darker and smaller portions of the chart), which has not been covered as of the moment.",
      ],
      visual: "func-stack",
      parts: [
        {
          category: "Primary Functions",
          subparts: [
            {
              subcategory: "1) Dominant (Dom)",
              description:
                "Your strongest function you use often you might not realize you use it at all. The first function in the function stack.",
            },
            {
              subcategory: "2) Auxiliary (Aux)",
              description:
                "Your second strongest function which helps and assist your dominant function.",
            },
            {
              subcategory: "3) Tertiary (Ter)",
              description:
                "Your third function is considered to be under-developed but develops as you mature.",
            },
            {
              subcategory: "4) Inferior (Inf)",
              description:
                "A fourth function that comes out mostly when you’re under stress. This is also your most insecure function lies.",
            },
          ],
        },
      ],
    },
    {
      title:
        "V. How do the Cognitive Functions determine the 4 letter MBTI code?",
      subtitle: "Putting it all together",
      description: [
        "The Myers-Briggs Type Indicator (MBTI) was created and derived from the theory of psychological types described by Carl Jung. It's goal is to make the cognitive functions more understandable.",
        "Using the chart, we can easily variations and differences in priorities in using your Cognitive Functions.",
      ],
      parts: [
        {
          category:
            "How are the cognitive functions being derived to the 4 letter MBTI?",
          subparts: [
            {
              subcategory: "1st letter (E or I) - which attitude?",
              description:
                "Is your Dominant function Extraverted (E) or Introverted (I)?",
            },
            {
              subcategory: "2nd letter (N or S) - which Perceiving function?",
              description:
                "Is your Dominant or Auxiliary function Intuition (N) or Sensing (S)?",
            },
            {
              subcategory: "3rd letter (T or F) -  which Judging function?",
              description:
                "Is your Dominant or Auxiliary function Thinking (T) or Feeling (F)?",
            },
            {
              subcategory: "4th letter (P or J) - what function type?",
              description:
                "Is the type of dominant function you have Perceiving (P) or Judging (J)? For the Introverted function, it is determined by the auxiliary function.",
            },
          ],
        },
      ],
    },
  ],
  footer: {
    sources: [
      {
        source: "The Myers & Briggs Foundation",
        article: "The Eight Function Attitudes",
        url: "myersbriggs.org",
      },
      {
        source: "verywellmind.com",
        article: "Myers-Briggs Type Indicator: The 16 Personality Types",
        url: "verywellmind.com",
      },
      {
        source: "Well+Good",
        article:
          "8 MBTI functions explain how personality tests act in the world",
        url: "wellandgood.com",
      },
      {
        source: "Career Planner",
        article:
          "Introverted Intuiting (Ni) Explained - One of Your Eight Cognitive Functions (careerplanner.com)",
        url: "8 cognitive functions",
      },
    ],
    links: [
      {
        site: "Joseph Ricafort",
        url: "https://josericafort.com",
        img: "logo_jr.png",
      },
      {
        site: "The Lost Kite",
        url: "https://thelostkite.com",
        img: "logo_thelostkite.png",
      },
    ],
  },
};
